import {
    Button,
    Modal,
    ModalActions,
    ModalContent,
    ModalTitle,
    TextField,
} from '@deere/fuel-react';
import React, { useContext, useState } from 'react';
import styles from '../../pages/Admin/ActiveJobDetails.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { LoggedInContext } from '../../context/LoggedInContext';
import { errorBannerFromResponse } from '../../utils/errorBanner';

export const CancelJobModal = (props) => {
    const [isCancelButtonClicked, setIsCancelButtonClicked] = useState(false);
    const params = useParams();
    const [notes, setNotes] = useState('');
    const [notesIsDirty, setNotesIsDirty] = useState(false);
    const [errorText, setErrorText] = useState('');
    const navigate = useNavigate();
    const { makeRequest } = useContext(LoggedInContext);

    const isNotesValid = (value) => {
        if (!/^\s*$/.test(value)) {
            setNotesIsDirty(true);
            setErrorText('');
        } else {
            setNotesIsDirty(false);
        }
        return value;
    };

    const notesHandler = (event) => {
        setNotes(event.target.value);
        isNotesValid(event.target.value);
    };

    const closeCancelModal = () => {
        setIsCancelButtonClicked(false);
        setNotes('');
        setNotesIsDirty(false);
    };
    const openCancelModal = () => {
        setIsCancelButtonClicked(true);
        setNotes('');
        setNotesIsDirty(true);
        setErrorText('');
    };
    const saveHandler = async () => {
        try {
            if (notesIsDirty === true && notes !== '') {
                props.jobObj.notes = notes;
                const requestOptions = {
                    method: 'POST',
                    body: JSON.stringify(props.jobObj),
                };

                const response = await makeRequest(
                    process.env.REACT_APP_API_ENDPOINT +
                        '/job/' +
                        params.jobNumber +
                        '/cancelJob',
                    requestOptions
                );

                if (response.status === 200) {
                    setIsCancelButtonClicked(false);
                    navigate('/closed-jobs');
                } else {
                    setErrorText(
                        errorBannerFromResponse(
                            response,
                            'This job was not marked as posted in error. Please try again later.'
                        ).message
                    );
                }
            } else {
                setErrorText(
                    'You must enter notes that explain why you are marking this job as posted in error'
                );
                setNotesIsDirty(false);
            }
        } catch (err) {
            setErrorText(
                errorBannerFromResponse(
                    err,
                    'This job was not marked as posted in error. Please try again later.'
                ).message
            );
        }
    };

    return (
        <>
            <Modal
                open={isCancelButtonClicked}
                onClose={closeCancelModal}
                aria-labelledby="alert-Modal-title"
                aria-describedby="alert-Modal-description"
                maxWidth="xs"
                fullWidth={true}
            >
                <ModalTitle id="alert-Modal-title">
                    Mark Job as Posted in Error
                </ModalTitle>
                <ModalContent>
                    By marking this job as posted in error, you will permanently
                    close this job and any winners already marked successful
                    will be removed. This job posting will be moved to the
                    Closed & Assigned list.
                    <br />
                    <br />
                    <TextField
                        id="notes"
                        required={true}
                        label="Notes"
                        type="text"
                        placeholder={'Notes'}
                        multiline
                        minRows={3}
                        value={notes}
                        onChange={notesHandler}
                        helperText={errorText}
                        error={!notesIsDirty}
                    />
                </ModalContent>
                <ModalActions>
                    <Button onClick={closeCancelModal} variant="secondary">
                        Cancel
                    </Button>
                    <Button onClick={saveHandler} variant="primary">
                        Save
                    </Button>
                </ModalActions>
            </Modal>

            <Button
                variant="secondary"
                onClick={openCancelModal}
                className={styles.pageLevelButton}
            >
                Cancel This Job - Mark as Posted in Error
            </Button>
        </>
    );
};
